import reservationEditor from './index.js';
import _ from 'lodash';

/* istanbul ignore next line */
const SET_LOADING_CUSTOMER_RESERVATIONS = (state, loadingCustomerReservations) => {
  state.loadingCustomerReservations = loadingCustomerReservations
};
const SET_LOADING_RESERVATIONS = (state, loadingReservations) => {
  state.loadingReservations = loadingReservations
};

const SET_RESERVATIONS = (state, reservations) => {
  state.reservations = reservations
};

const SET_CUSTOMER_RESERVATIONS = (state, customerReservations) => {
  state.customerReservations = customerReservations;
};

const CLONE_SELECTED_RESERVATION_FOR_EDITING = (state, reservation)=>{
  let clone = _.cloneDeep(reservation);
  state.reservation.salesRepId = clone.sales_rep!=null ? clone.sales_rep.id : null;
  state.reservation.quantity = clone.quantity;
  state.reservation.selectedContacts= clone.follow_up_contacts;
  state.reservation.id=clone.id;
  let detailLine = {};
  detailLine.product = clone.product;
  detailLine.product.quantity = detailLine.product.quantities[0];
  detailLine.product.quantities = null;
  detailLine.comment = clone.comment;
  delete detailLine.product.quantities;
  detailLine.qty=clone.qty;
  state.reservation.details.push(detailLine);
}

const REMOVE_CUSTOMER_RESERVATION = (state, index) =>{
  state.customerReservations.splice(index,1);
}

const SET_LOADING_CUSTOMERS = (state, loadingCustomers)=>{
  state.loadingCustomers = loadingCustomers;
}

const SET_CUSTOMERS = (state, customers)=>{
  state.customers = customers;
}

const SET_RESERVATION_TO_CREATE_CUSTOMER = (state, {customerId,customer})=>{
  if(customer){
    state.reservation.customer = customer;
  }else{
    // console.log("SET CUSTOMER")
    state.reservation.customer = {};
    state.reservation.customer.id=customerId;
  }

}

const ADD_DETAIL_LINE = (state, newLine)=>{
  state.reservation.details.push(newLine);
}

const SET_DETAIL_ITEMS_LOADING = (state, detailItemsLoading)=>{
  state.loadingDetailItems=detailItemsLoading;
}

const SET_DETAIL_QTY = (state, {index, qty})=>{
  state.reservation.details[index].qty=qty;
}

const SET_COMMENT = (state, {index, comment})=>{
  state.reservation.details[index].comment=comment;
}

const REMOVE_DETAIL_ITEM_LINE = (state, index)=>{
  state.reservation.details.splice(index,1);
}

const SET_NEW_RESERVATION_SALES_REP = (state, salesRepId)=>{
  state.reservation.salesRepId = salesRepId;
}

const RESET_STATE = state => {
  Object.assign(state, reservationEditor.getDefaultState());
};

const SET_DELAYED = (state, {index, delayed})=>{
  // console.log(state.reservation.details[index]);
  state.reservation.details[index].delayed = delayed;
}

const UDPATE_DETAIL_LINES = (state, lines)=>{
  _.forEach(lines, line=>{
    let storeDetailLine = _.find(state.reservation.details, item=>{return item.product.id==line.product.id});
    if(line.delayed==="true"||line.delayed==true){
      line.delayed=true;
    }else{
      line.delayed=false;
    }
    Object.assign(storeDetailLine, line);

  })
}

const SET_SELECTED_CONTACTS = (state, contacts)=>{
  state.reservation.selectedContacts=contacts;
}

const SET_EDITOR_LOADING = (state, editorLoading) => {
  state.editorLoading = editorLoading
};

const RESERVATION_SET_CUSTOMER = (state, customer) => {
  state.reservation.customer = customer;
}

const SET_RESERVATION_TYPE = (state, { index, type }) => {
  state.reservation.details[index].type = type;
}




export default {
  RESERVATION_SET_CUSTOMER,
  SET_LOADING_CUSTOMER_RESERVATIONS,
  SET_CUSTOMER_RESERVATIONS,
  REMOVE_CUSTOMER_RESERVATION,
  SET_LOADING_CUSTOMERS,
  SET_CUSTOMERS,
  SET_RESERVATION_TO_CREATE_CUSTOMER,
  ADD_DETAIL_LINE,
  SET_DETAIL_ITEMS_LOADING,
  SET_DETAIL_QTY,
  REMOVE_DETAIL_ITEM_LINE,
  SET_NEW_RESERVATION_SALES_REP,
  RESET_STATE,
  SET_LOADING_RESERVATIONS,
  SET_RESERVATIONS,
  CLONE_SELECTED_RESERVATION_FOR_EDITING,
  SET_DELAYED,
  UDPATE_DETAIL_LINES,
  SET_COMMENT,
  SET_SELECTED_CONTACTS,
  SET_EDITOR_LOADING,
  SET_RESERVATION_TYPE
};
